// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__25JiQ","title":"Header_title__3DPiW","side":"Header_side__1HhZK"};